<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          label="Transit Number"
          ref="transitNumber"
          v-model="transitNumber"
          :rules="[() => !!transitNumber || 'This field is required']"
          placeholder="12345"
          @input="handleInput"/>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          label="Institution Number"
          ref="institutionNumber"
          :rules="[() => !!institutionNumber || 'This field is required']"
          v-model="institutionNumber"
          placeholder="000"
          @input="handleInput"/>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          label="Account Number"
          v-model="accountNumber"
          ref="accountNumber"
          :rules="[() => !!accountNumber || 'This field is required']"
          placeholder="000123456789"
          @input="handleInput"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formValidation } from '../../mixins/validation.mixins';

export default {
  mixins: [formValidation],
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      transitNumber: this.value.routingNumber,
      institutionNumber: this.value.routingNumber,
      accountNumber: this.value.accountNumber,
    };
  },
  methods: {
    handleInput() {
      this.$emit('input', {
        routingNumber: this.transitNumber + this.institutionNumber,
        accountNumber: this.accountNumber,
      });
    },
  },
};
</script>
